import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../providers/auth_provider';
import { toast } from 'react-toastify';
import DeleteConfirmation from './modal/confirmation';
import { Helmet } from 'react-helmet';

const AddMusic = () => {
    const { token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [musicFile, setMusicFile] = useState(null);
    const [uploadedMusic, setUploadedMusic] = useState([]);

    const handleFileChange = (e) => {
        setMusicFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!musicFile) {
            toast.error("Please select a music file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append('music_audio', musicFile);

        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/music/create`, formData, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            toast.success('Music uploaded successfully!');
            fetchUploadedMusic();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchUploadedMusic = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/music/all`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setUploadedMusic(response.data.music);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchUploadedMusic();
    }, []);

    return (
        <>
            <Helmet>
                <title>Manage Musics - Enervybe</title>
            </Helmet>
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">Musics List</h5>
                    </div>
                </div>
                <div>
                    <form onSubmit={handleSubmit} className="mt-4 container mt-5">
                        <div className="mb-3">
                            <label htmlFor="musicFile" className="form-label">Upload Music</label>
                            <input
                                type="file"
                                className="form-control"
                                id="musicFile"
                                accept="audio/*"
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className='text-end'>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? 'Please wait..' : 'Upload'}
                            </button>
                        </div>
                    </form>

                    <h5 className="mx-5 pt-4">Uploaded Music</h5>
                    <div className="table-responsive mt-3">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Music</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {uploadedMusic?.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            No music uploaded yet.
                                        </td>
                                    </tr>
                                ) : (
                                    uploadedMusic?.map((music, index) => (
                                        <tr key={music.id}>
                                            <th scope="row">{index + 1}</th>
                                            <td>
                                                <audio controls controlsList="nodownload">
                                                    <source src={music.music_audio} type="audio/mp3" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                            </td>
                                            <td className="d-flex align-items-center">
                                                <DeleteConfirmation
                                                    music={music}
                                                    fetchUploadedMusic={fetchUploadedMusic}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddMusic;
